<script setup lang="ts">
import { RouterView } from "vue-router";
import { storeToRefs } from "pinia";

import { useAccount } from "@/stores/account.ts";

import AuthenticatedWrapper from "@/wrappers/AuthenticatedWrapper.vue";

const account = useAccount();

const { profile } = storeToRefs(account);
</script>

<template>
  <AuthenticatedWrapper v-if="profile"></AuthenticatedWrapper>
  <RouterView v-else />
</template>
